import styled from "@emotion/styled";
import { FC } from "react";
import { useSelector } from "react-redux";

import { Add } from "@livechat/design-system-icons";
import { DesignToken, Icon, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { useOrganization } from "hooks/use-organizations";
import { selectIsAdmin, selectIsAgent } from "store/entities/agents";
import { withVar } from "themes/helpers";

import { ColumnWidths } from "./styled";

interface IProps {
  onClick: VoidFunction;
}

export const AddAgentRow: FC<IProps> = ({ onClick }) => {
  const { organization } = useOrganization();

  const isAdminLogged = useSelector(selectIsAdmin);
  const isAgentLogged = useSelector(selectIsAgent);

  const agentsCanSendInvitations = organization?.invitationMode === "lax";
  const canInviteUsers = isAdminLogged || (isAgentLogged && agentsCanSendInvitations);

  if (!canInviteUsers) return null;

  return (
    <Wrapper onClick={onClick} role="button" aria-label="add-agent-button">
      <Flex minWidth={ColumnWidths.Avatar} alignItems="center" justifyContent="flex-end" paddingLeft="10px">
        <Flex
          width="40px"
          height="40px"
          borderRadius="50%"
          alignItems="center"
          justifyContent="center"
          bg={withVar(DesignToken.ActionPrimaryDefault)}
        >
          <Icon source={Add} kind="inverted" />
        </Flex>
      </Flex>
      <Text bold customColor={withVar(DesignToken.ContentBasicPrimary)}>
        Add new agent
      </Text>
    </Wrapper>
  );
};

const Wrapper = styled(Flex)`
  min-height: 70px;
  align-items: center;
  gap: 28px;
  cursor: pointer;
  transition: background-color 0.2s;
  border-bottom: solid 1px ${withVar(DesignToken.BorderBasicSecondary)};

  &:hover {
    background: ${withVar(DesignToken.SurfacePrimaryHover)};
  }
`;
